export default __webpack_public_path__ + "locales/es/OAuth.json?hash=7139da6e9fc4117ea7c7217bf9fa517f";